<template>
  <div id="blade5">
    <blade5a />
    <blade5b />
  </div>
</template>

<script>
import Blade5a from "./blade5-sections/Blade5a";
import Blade5b from "./blade5-sections/Blade5b";

export default {
  name: "Blade5",
  components: {
    Blade5a,
    Blade5b
  }
};
</script>

<style lang="scss">
</style>